
export default {
  name: 'BaseSliderIndicator',
  props: {
    itemCount: {
      type: Number,
      default: 0,
    },
    selectedItem: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    onClick: function(e) {
      this.$emit('click', e);
    },
  },
};
